import { Portal, PortalType } from '../enums/portal.enum';

const imageUrl = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/flags`;

export const portalItems = [
  {
    label: 'Philippines',
    logo: `${imageUrl}/ph-logo.webp`,
    id: Portal.PHILIPPINES,
    type: PortalType.COUNTRY,
  },
  {
    label: 'United States of America',
    logo: `${imageUrl}/us-logo.webp`,
    id: Portal.USA,
    type: PortalType.COUNTRY,
  },
  {
    label: 'International Baccalaureate (IB)',
    logo: `${imageUrl}/ib-logo.webp`,
    id: Portal.INTERNATIONAL,
    type: PortalType.CURRICULUM,
  },
  {
    label: 'Global',
    logo: `${imageUrl}/gb-logo.webp`,
    id: Portal.DEFAULT,
    type: PortalType.COUNTRY,
  },
  // {
  //   label: 'Montessori',
  //   logo: `${imageUrl}/mn-logo.png`,
  //   id: Portal.MONTESSORI,
  // },
];
